import { useFormContext, Controller } from 'react-hook-form';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

type RHFTextareaProps = {
  name: string;
  placeholderText: string;
};

export default function RHFTextarea({ name, placeholderText }: RHFTextareaProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <ReactQuill
          value={field.value || ''}
          onChange={field.onChange}
          onBlur={field.onBlur}
          placeholder={placeholderText}
          style={{ height: 200, borderRadius: 15 }}
        />
      )}
    />
  );
}
